import { configureStore } from "@reduxjs/toolkit";
import LOGIN from "../api/Auth/Login";
import LOGIN_OTP from "../api/Auth/Login/otp";
import DOWNLOAD_SAMPLE_STUDENT from "../api/Sample/Student/index";
import UPLOAD_BULK_STUDENT from "../api/Upload/Student/index";
import GET_STUDENT_LIST from "../api/Data/Student/index";
import GET_ORGANISATION from "../api/Organisation/index";
import {
  createSlotsReducer,
  createUnavialableReducer,
  deleteAllScheduleReducer,
  deleteAllUnavailableReducer,
  deleteScheduleReducer,
  deleteUnavailableReducer,
  editUnailableReducer,
  getAppointmentCounterReducer,
  getAppointmentDetailReducer,
  getAppointmentReducer,
  getAppointmentSummaryReducer,
  getPastAppointmentReducer,
  getSlotsReducer,
  getUnavialableAppointmentReducer,
  getUnavialableReducer,
  updateSlotsReducer,
  getAvailableSlotReducer,
  createAppointmentReducer,
  getFollowUpAppointmentReducer,
  getFollowUpAppointmentCounterReducer,
} from "../slice/Appointment";
import {
  getDeliveryTrendReducer,
  getQuickStatsReducer,
  getRiskStatusReducer,
} from "../slice/Stats";
import { getUserDataReducer, updateProfileReducer } from "../slice/Profile";
import {
  getCityReducer,
  getCountryReducer,
  getLanguageReducer,
  getStateReducer,
} from "../slice/Location";
import CONSULTATION_OBSERVATION from "../api/Call/ConsultationObservationSlice";
export const store = configureStore({
  reducer: {
    login: LOGIN,
    loginOtp: LOGIN_OTP,
    downloadSampleStudent: DOWNLOAD_SAMPLE_STUDENT,
    uploadBulkStudent: UPLOAD_BULK_STUDENT,
    getStudentLists: GET_STUDENT_LIST,
    getOrgData: GET_ORGANISATION,
    APPOINTMENT_SUMMARY: getAppointmentSummaryReducer,
    GET_APPOINTMENT: getAppointmentReducer,
    GET_QUICK_STATS: getQuickStatsReducer,
    GET_DELIVERY_TREND: getDeliveryTrendReducer,
    GET_RISK_STATUS: getRiskStatusReducer,
    GET_PAST_APPOINTMENT: getPastAppointmentReducer,
    GET_USER_PROFILE: getUserDataReducer,
    GET_COUNTRY: getCountryReducer,
    GET_STATE: getStateReducer,
    GET_CITY: getCityReducer,
    GET_LANAGUAGE: getLanguageReducer,
    UPDATE_PRACTITIONER: updateProfileReducer,
    APPOINTMENT_COUNTER: getAppointmentCounterReducer,
    GET_SLOTS: getSlotsReducer,
    CREATE_SLOTS: createSlotsReducer,
    UPDATE_SLOT: updateSlotsReducer,
    CREATE_UNAVIALABLE: createUnavialableReducer,
    GET_UNAVIALABLE: getUnavialableReducer,
    GET_UNAVIALABLE_APPOINTMENT: getUnavialableAppointmentReducer,
    UPDATE_UNAVAILABLE: editUnailableReducer,
    DELETE_UNAVAILABLE: deleteUnavailableReducer,
    GET_APPOINTMENT_DETAIL: getAppointmentDetailReducer,
    DELETE_SCHEDULE: deleteScheduleReducer,
    DELETE_ALL_SCHEDULE: deleteAllScheduleReducer,
    DELETE_ALL_UNAVAILABLE: deleteAllUnavailableReducer,
    CONSULTATION_OBSERVATION: CONSULTATION_OBSERVATION,
    GET_AVAILABLE_SLOT: getAvailableSlotReducer,
    CREATE_APPOINTMENT: createAppointmentReducer,
    GET_FOLLOW_UP_APPOINTMENT: getFollowUpAppointmentReducer,
    FOLLOW_UP_APPOINTMENT_COUNTER: getFollowUpAppointmentCounterReducer,
  },
});
